module.exports = __webpack_public_path__ + "img/icon_map_zyz.1fb9a3aa.png";